export const assistantConstant = {
    UPDATE_ASSISTANT_REQUEST: 'UPDATE_ASSISTANT_REQUEST',
    UPDATE_ASSISTANT_SUCCESS: 'UPDATE_ASSISTANT_SUCCESS',
    UPDATE_ASSISTANT_FAILURE: 'UPDATE_ASSISTANT_FAILURE',

    LOAD_TIP_MESSAGE_BY_ID_REQUEST: 'LOAD_TIP_MESSAGE_BY_ID_REQUEST',
    LOAD_TIP_MESSAGE_BY_ID_SUCCESS: 'LOAD_TIP_MESSAGE_BY_ID_SUCCESS',
    LOAD_TIP_MESSAGE_BY_ID_FAILURE: 'LOAD_TIP_MESSAGE_BY_ID_FAILURE',
};
